export const serviceAddressSchema = {
  title: "Service Address",
  type: "object",
  required: ["serviceAddressSection0"],
  properties: {
    serviceAddressSection0: {
      type: "object",
      title: "Service Address",
      description: "",
      required: [
        "serviceAddressStreet",
        "serviceAddressCity",
        "serviceAddressState",
        "serviceAddressZipCode",
        "preferredPhone"
      ],
      properties: {
        serviceAddressStreet: {
          type: "string",
          title: "Address Line 1",
          minLength: 1,
          maxLength: 65,
          errorMessage: {
            required: "Address line 1 is required",
            minLength: "Address line 1 cannot be empty",
            maxLength: "Address line 1 must be under 65 characters"
          }
        },
        serviceAddress1: {
          type: "string",
          title: "Address Line 2",
          maxLength: 65,
          errorMessage: {
            maxLength: "Address line 2 must be under 65 characters"
          }
        },
        serviceAddressCity: {
          type: "string",
          title: "City",
          minLength: 1,
          maxLength: 30,
          pattern: "^[A-Za-z .'-]{1,30}$",
          errorMessage: {
            required: "City is required",
            minLength: "City cannot be empty",
            maxLength: "City must be under 30 characters",
            pattern: "City name can only contain letters, spaces, dots, and dashes"
          }
        },
        serviceAddressState: {
          type: "string",
          title: "State",
          enum: ["Texas"],
          default: "Texas",
          description: "Cambridge Caregivers only provides services in Texas",
          errorMessage: {
            required: "State is required"
          }
        },
        serviceAddressZipCode: {
          type: "string",
          title: "ZIP Code",
          pattern: "^[0-9]{5}$",
          errorMessage: {
            required: "ZIP code is required",
            pattern: "ZIP code must be exactly 5 digits",
          }
        },
        homePhone: {
          type: "string",
          title: "Home Phone",
          pattern: "^(\\(\\d{3}\\) \\d{3}-\\d{4})?$",

          errorMessage: {
            pattern: "Enter a valid phone number in format (xxx) xxx-xxxx",
          }
        },
        mobilePhone: {
          type: "string",
          title: "Mobile Phone",
          pattern: "^(\\(\\d{3}\\) \\d{3}-\\d{4})?$",
          errorMessage: {
            pattern: "Enter a valid phone number in format (xxx) xxx-xxxx",
          }
        },
        email: {
          type: "string",
          title: "Email",
          format: "email",
          maxLength: 85,
          errorMessage: {
            format: "Please enter a valid email address",
            maxLength: "Email must be under 85 characters",
          }
        },
        preferredPhone: {
          type: "string",
          title: "Preferred Phone",
          enum: ["Home", "Mobile"],
          default: "Mobile",
          errorMessage: {
            required: "Please select a preferred phone"
          }
        }
      }
    }
  }
};


export const serviceAddressUiSchema = {
  serviceAddressSection0: {
    serviceAddressStreet: { "ui:md": 12 },
    serviceAddress1: { "ui:md": 12 },
    serviceAddressCity: { "ui:md": 6 },
    serviceAddressState: { "ui:md": 6, "ui:disabled": true, },
    serviceAddressZipCode: {
      "ui:md": 6, "ui:widget": "NumberWidget",
      "ui:options": {
        hideError: false,
        digitsOnly: true,
        maxLength: 5,
        inputMode: "numeric"
      }
    },
    homePhone: {
      "ui:md": 6, "ui:widget": "PhoneWidget", "ui:options": {
        inputType: "tel",
        disabled: false,
        readonly: false,
        hideError: false,
      },
    },
    mobilePhone: {
      "ui:md": 6, "ui:widget": "PhoneWidget", "ui:options": {
        inputType: "tel",
        disabled: false,
        readonly: false,
        hideError: false,
      },
    },
    email: { "ui:md": 6 },
    preferredPhone: { "ui:md": 6, "ui:widget": "radio", "ui:options": { inline: true } },
  },
};